
var siteVideo = null;
if (($('body').is('.home') || $('body').is('.home-explorer')) && document.querySelector('.video[data-video-id]')) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/player_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    function onYouTubeIframeAPIReady() {
        siteVideo = new SiteVideo();
    }
}

class SiteVideo {
    constructor() {
        const _ = this;

        _.videoId = $('.video[data-video-id]').data('video-id');
        _.player = null;
        _.duration = 0;
        _.isPlayerReady = false;
        _.isPlaying = false;

        if (_.videoId) {
            new YT.Player(document.querySelector('.video[data-video-id]'), {
                height: '100%',
                width: '100%',
                videoId: _.videoId,
                host: 'https://www.youtube-nocookie.com',
                playerVars: {
                    autoplay: 1,
                    controls: 0,
                    disablekb: 1,
                    enablejsapi: 1,
                    rel: 0,
                    showinfo: 0,
                    modestbranding: 1,
                    vq: 'hd1080'
                },
                events: {
                    'onReady': _.onReady,
                    'onStateChange': _.onPlayerStateChange
                }
            });
        }
    }
    start() {
        const _ = this;

        _.player.mute();
        _.player.playVideo();
        $(`.video[data-video-id="${_.videoId}"]`).addClass('loaded');
    }
    onReady(event) {
        const _ = siteVideo;
        _.player = event.target;
        _.isPlayerReady = true;

        _.start();
        _.player.setPlaybackQuality('hd1080');
    }
    onPlayerStateChange(event) {
        const _ = siteVideo;

        switch (event.data) {
            case YT.PlayerState.PLAYING:
                _.onPlay();
                break;
            case YT.PlayerState.PAUSED:
                _.onPause();
                break;
            case YT.PlayerState.ENDED:
                _.onEnded();
                break;
        }
    }
    onPlay() {
        const _ = this;

        _.duration = _.player.getDuration();

        _.isPlaying = true;
        _.timeUpdate();
    }
    onPause() {
        const _ = this;

        _.isPlaying = false;

        if (typeof _.isPlayerReady == 'undefined' || !_.isPlayerReady)
            return false;
    }
    onEnded() {
        const _ = this;

        _.isPlaying = false;
    }
    timeUpdate() {
        const _ = this;

        requestAnimationFrame(() => {
            if (typeof _.isPlayerReady != 'undefined' && _.isPlayerReady && _.isPlaying && _.player.getPlayerState() != 1)
                return false;

            _.onTimeUpdate();
            _.timeUpdate();
        });
    }
    onTimeUpdate() {
        const _ = this;

        if (typeof _.isPlayerReady == 'undefined' || !_.isPlayerReady || !_.isPlaying)
            return;

        const currentTime = parseFloat(_.player.getCurrentTime());

        if (currentTime >= _.duration - 1)
            _.player.seekTo(0);
    }
};
